import React from 'react';
import { ShieldCheck, CircleCheck } from 'lucide-react';
export const Guarantee = () => {
  return <section id="guarantee" className="w-full py-16 bg-gray-50" data-id="element-43">
      <div className="container mx-auto px-4 md:px-8" data-id="element-44">
        <div className="bg-white p-8 rounded-lg shadow-md border border-gray-200" data-id="element-45">
          <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-46">
            <div className="md:w-1/4 flex justify-center" data-id="element-47">
              <div className="bg-gray-100 p-4 rounded-full" data-id="element-48">
                <ShieldCheck className="w-24 h-24 text-gray-700" data-id="element-49" />
              </div>
            </div>
            <div className="md:w-3/4" data-id="element-50">
              <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900" data-id="element-51">
                60-Day Risk-Free Guarantee
              </h2>
              <p className="text-xl mb-4 text-gray-800" data-id="element-52">
                The sleeve I used is{' '}
                <span className="font-bold" data-id="element-53">available online</span> here in the
                UK.
              </p>
              <p className="text-xl mb-4 text-gray-800" data-id="element-54">
                You <span className="font-bold" data-id="element-55">don't need</span> a
                prescription.
              </p>
              <p className="text-xl mb-4 text-gray-800" data-id="element-56">
                You <span className="font-bold" data-id="element-57">don't need</span> to wait months
                for an NHS referral.
              </p>
              <p className="text-xl mb-4 text-gray-800" data-id="element-58">
                You just <span className="font-bold" data-id="element-59">slide it on</span> before
                bed.
              </p>
              <p className="text-xl mb-4 text-gray-800" data-id="element-60">
                And let your body{' '}
                <span className="font-bold" data-id="element-61">finally rest</span>.
              </p>
              <p className="text-xl mb-4 font-bold text-gray-900" data-id="element-62">
                Right now, they're offering a 60-day risk-free trial.
              </p>
              <p className="text-xl mb-4 text-gray-800" data-id="element-63">
                That means if it doesn't help you, you get{' '}
                <span className="font-bold" data-id="element-64">your money back</span>.
              </p>
              <p className="text-xl mb-4 text-gray-800" data-id="element-65">No questions asked.</p>
              <p className="text-xl font-bold text-gray-900" data-id="element-66">
                But if it works…
              </p>
              <p className="text-xl font-bold text-gray-900" data-id="element-67">
                You'll finally know what it feels like to wake up rested again.
              </p>
            </div>
          </div>
          {/* Product Close-up */}
          <div className="mt-8 border-t border-gray-200 pt-8" data-id="element-68">
            <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-69">
              <div className="md:w-1/2" data-id="element-70">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ijNgvgm5JFkTKoiQMrJ8kw/OC11_ProductImage_IMG2-1_a15a5d15-5a44-447b-8016-8d24db25bfce_%284%29.jpg" alt="Close-up of knee sleeve on leg" className="rounded-lg shadow-md w-full" data-id="element-71" />
              </div>
              <div className="md:w-1/2" data-id="element-72">
                <h3 className="text-2xl font-bold mb-4 text-gray-900" data-id="element-73">
                  The Vital Relief™ Sleep-Through-The-Night Knee Sleeve
                </h3>
                <ul className="space-y-4" data-id="element-74">
                  <li className="flex items-start gap-3" data-id="element-75">
                    <div className="mt-1 flex-shrink-0" data-id="element-76">
                      <CircleCheck className="w-6 h-6 text-gray-700" data-id="element-77" />
                    </div>
                    <p className="text-xl text-gray-800" data-id="element-78">
                      <span className="font-bold" data-id="element-79">Lightweight, breathable</span>{' '}
                      fabric that won't make you hot
                    </p>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-80">
                    <div className="mt-1 flex-shrink-0" data-id="element-81">
                      <CircleCheck className="w-6 h-6 text-gray-700" data-id="element-82" />
                    </div>
                    <p className="text-xl text-gray-800" data-id="element-83">
                      <span className="font-bold" data-id="element-84">Gentle compression</span> that
                      maintains healthy circulation
                    </p>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-85">
                    <div className="mt-1 flex-shrink-0" data-id="element-86">
                      <CircleCheck className="w-6 h-6 text-gray-700" data-id="element-87" />
                    </div>
                    <p className="text-xl text-gray-800" data-id="element-88">
                      <span className="font-bold" data-id="element-89">Stays in place</span> all
                      night without bunching or rolling down
                    </p>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-90">
                    <div className="mt-1 flex-shrink-0" data-id="element-91">
                      <CircleCheck className="w-6 h-6 text-gray-700" data-id="element-92" />
                    </div>
                    <p className="text-xl text-gray-800" data-id="element-93">
                      Designed specifically for{' '}
                      <span className="font-bold" data-id="element-94">
                        nighttime wear and comfort
                      </span>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};